var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export class AIPartnerDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], AIPartnerDto.prototype, "id", void 0);
__decorate([
    IsString()
], AIPartnerDto.prototype, "orgId", void 0);
__decorate([
    IsString()
], AIPartnerDto.prototype, "projectId", void 0);
__decorate([
    IsString()
], AIPartnerDto.prototype, "name", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], AIPartnerDto.prototype, "outboundIps", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerDto.prototype, "outboundIpsFetchUrl", void 0);
__decorate([
    IsBoolean()
], AIPartnerDto.prototype, "isActive", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], AIPartnerDto.prototype, "showInList", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], AIPartnerDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], AIPartnerDto.prototype, "updatedAt", void 0);
export class CreateAIPartnerInput {
}
__decorate([
    IsString()
], CreateAIPartnerInput.prototype, "orgId", void 0);
__decorate([
    IsString()
], CreateAIPartnerInput.prototype, "projectId", void 0);
__decorate([
    IsString()
], CreateAIPartnerInput.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], CreateAIPartnerInput.prototype, "outboundIps", void 0);
__decorate([
    IsOptional(),
    IsString()
], CreateAIPartnerInput.prototype, "outboundIpsFetchUrl", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], CreateAIPartnerInput.prototype, "isActive", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], CreateAIPartnerInput.prototype, "showInList", void 0);
export class UpdateAIPartnerInput {
}
__decorate([
    IsOptional(),
    IsString()
], UpdateAIPartnerInput.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], UpdateAIPartnerInput.prototype, "outboundIps", void 0);
__decorate([
    IsOptional(),
    IsString()
], UpdateAIPartnerInput.prototype, "outboundIpsFetchUrl", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], UpdateAIPartnerInput.prototype, "isActive", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], UpdateAIPartnerInput.prototype, "showInList", void 0);
export class AIPartnersResult {
}
__decorate([
    IsNumber()
], AIPartnersResult.prototype, "total", void 0);
__decorate([
    Type(() => AIPartnerDto),
    ValidateNested({ each: true })
], AIPartnersResult.prototype, "results", void 0);
export class AIPartnerListItemDto {
}
__decorate([
    IsString()
], AIPartnerListItemDto.prototype, "id", void 0);
__decorate([
    IsString()
], AIPartnerListItemDto.prototype, "name", void 0);
__decorate([
    IsString()
], AIPartnerListItemDto.prototype, "projectId", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "studyTitle", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "patientFriendlyTitle", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "organizationIconUrl", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "organizationRectangularIconUrl", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "aiChatbotUrl", void 0);
__decorate([
    IsOptional(),
    IsString()
], AIPartnerListItemDto.prototype, "aiSharingUrl", void 0);
